
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FORM_FIELD } from '../../../ui/formTheme';

const EvaluationRadioGroup = ({ label, name, options = [], disabled = false, readOnly = false, className = "", isRequired = false }) => {
    const { register, watch, formState: { errors } } = useFormContext();

    // Helper to get nested error
    const getNestedError = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    const error = getNestedError(errors, name);
    const value = watch(name); // Watch value for readOnly/checked state handling if needed

    return (
        <div className={className}>
            {label && (
                <label className={FORM_FIELD.label}>
                    {label} {isRequired && <span className="text-red-500">*</span>}
                </label>
            )}
            <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2">
                {options.map((option) => {
                    const isSelected = String(value ?? "") === String(option.value);
                    return (
                        <label key={option.value} className={`flex items-center gap-2 ${readOnly ? '' : 'cursor-pointer'}`}>
                            <input
                                type="radio"
                                value={option.value}
                                {...register(name)}
                                disabled={disabled || readOnly}
                                // `disabled` (not readOnly) is what blocks interaction on a
                                // registered radio; the checked state still follows the form value.
                                className={`${FORM_FIELD.radio} ${readOnly ? 'cursor-default' : 'cursor-pointer'}`}
                            />
                            <span className={`text-sm ${isSelected ? 'text-indigo-800 font-medium' : 'text-slate-700'}`}>
                                {option.label}
                            </span>
                        </label>
                    );
                })}
            </div>
            {error && <p className={FORM_FIELD.errorText}>{error.message}</p>}
        </div>
    );
};

export default EvaluationRadioGroup;
